const account = {
    title: String("Perfil d'usuari"),
    terrains: String("Finques"),
    modules: String("Estacions"),
    myDataTitle: String("El meu perfil d'usuari"),
    aboutMeTitle: String("Sobre mi"),
    usernameLabel: String("Nom d'usuari"),
    nifLabel: String("DNI/NIF"),
    nifPlaceholder: String("12345678a"),
    emailLabel: String("Correu electrònic"),
    emailPlaceholder: String("Exemple&#64Exemple.com"),
    nameLabel: String("Nom"),
    namePlaceholder: String("Nom..."),
    lastName1Label: String("Cognom"),
    lastName1Placeholder: String("Cognom..."),
    lastName2Label: String("Segon cognom"),
    lastName2Placeholder: String("Segon cognom ..."),
    phoneLabel: String("Telèfon"),
    phonePlaceholder: String("123456789"),
    selectLanguage: String("Seleccioneu l'idioma"),
    contactInfoTitle: String("Informació de contacte"),
    addressSearchBarLabel: String("Adreça de cerca"),
    accountGoogleAskAddressPlaceholder: String("Exemple de carrer"),
    addressLabel: String("Direcció"),
    addressPlaceholder: String("Exemple de carrer"),
    numberLabel: String("Número"),
    numberPlaceholder: String("0"),
    cityLabel: String("Ciutat"),
    cityPlaceholder: String("Ciutat ..."),
    provinceLabel: String("Província"),
    provincePlaceholder: String("Província ..."),
    zipLabel: String("Codi Postal"),
    zipPlaceholder: String("12345"),
    regionLabel: String("Regió"),
    regionPlaceholder: String("Regió ..."),
    countryLabel: String("País"),
    countryPlaceholder: String("País ..."),
    updateButton: String("Actualitzar"),
    restoreButton: String("Restaurar"),
    errorFieldRequired: String("Aquest camp és obligatori"),
    errorFieldEmail: String("Adreça de correu electrònic invalida."),
    errorInvalidField: String("Camp no vàlid. Aquest camp només pot contenir lletres, guions (-) i espais."),
    errorInvalidNif: String("Format no vàlid. Aquest camp ha de contenir 8 números més una lletra. 01234567a"),
    errorFieldNumeric: String("Aquest camp només pot contenir números"),
    errorInvalidLength: String("Nombre de caràcters mínims: {length}"),
    errorsModalTitle: String("Error d'actualització"),
    errorsModalBodyTitle: String("Hi ha hagut algun error durant l'actualització"),
    errorsModalCloseButton: String("Tancar"),
};

export default account;
